export default {
  PleaseReview: 'Please check the video and if you like it, you can start uploading below.',
  PleaseLogin: 'To be able to assing videos to users, you need to login before uploading.',
  SearchController: {
    WordNotFound: 'Sorry, sadly the word couldn\'t be found. Please <a href="{{where}}">suggest it here</a>.',
  },
};
